export default __webpack_public_path__ + "static/media/1842.3aaba2cc.png";